<div>
  @if (alertInfo.show) {
    <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false" class="mb-3">
      <strong>{{ alertInfo.type === 'danger' ? 'Error!' : 'Success!' }}</strong>
      <div [innerHTML]="alertInfo.message"></div>
    </ngb-alert>
  }

  <form [formGroup]="form" class="mb-3">
    <div class="row">


      <div class="col-sm-7">
        <div class="row">
          <div class="col-sm-6">
            <input-field [label]="'Code'" [placeholder]="'Code'" [inputFormControl]="this.getEmployeeCode()"
              [readonly]="readonly">
          </input-field>
        </div>
        <div class="col-sm-6">
          <select-field [label]="'Working Company'"
            [selectFormControl]="getEmployeeCompanyLocationSelect()" [options]="locations"
            [readonly]="readonly">
          </select-field>
        </div>
        <div class="col-sm-6">
          <input-field [label]="'Engage Date'" [inputFormControl]="getEmployeeEngageTimeInput()"
            [type]="'date'" [readonly]="readonly">
        </input-field>
      </div>



      <div class="col-sm-6">
        <input-field [label]="'End Date'" [type]="'date'" [inputFormControl]="getEmployeeEndTimeInput()"
          [readonly]="readonly">
      </input-field>
    </div>
    <div class="col-sm-6">
      <input-field [label]="'Role'" [placeholder]="'Role'" [inputFormControl]="getEmployeeRoleInput()" [readonly]="readonly">
    </input-field>
  </div>
  <div class="col-sm-6">
    <select-field [label]="'Type of contract'" [selectFormControl]="getEmployeeContractTypeSelect()"
      [options]="contractTypes" [readonly]="readonly">
    </select-field>
  </div>
  <div class="col-sm-6">
    <input-field [label]="'Attitude'" [placeholder]="'Attitude'" [inputFormControl]="getEmployeeActitudeInput()"
      [readonly]="readonly">
  </input-field>
</div>
<div class="col-sm-6">
  <select-field [label]="'Status'" [selectFormControl]="getEmployeeStatusSelect()"
    [options]="statusOptions" [readonly]="readonly">
  </select-field>
</div>
</div>

</div>

<div class="col-sm-5">
  <div class="row">
    <div class="col-sm-12">
      <div class="d-flex justify-content-between align-items-center">
        <label class="form-label fw-bold mb-0">SPECIALISATION</label>
        <span class="badge bg-primary ms-2">{{ selectedSpecializationsCount }}</span>
      </div>
      <div class="specializations-container mt-2">
        <div class="row">
          @for (specialization of specializations; track specialization) {
            <div class="col-sm-12">
              <div class="form-check mb-2">
                <input class="form-check-input" type="checkbox"
                  [id]="'spec-' + specialization.employeeSpecialisationId"
                  [checked]="isSpecializationSelected(specialization.employeeSpecialisationId)"
                  (change)="toggleSpecialization(specialization.employeeSpecialisationId); $event.stopPropagation()"
                  [disabled]="readonly">
                <label class="form-check-label"
                  [for]="'spec-' + specialization.employeeSpecialisationId">
                  {{ specialization.name }}
                </label>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</form>

</div>